module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('grid-x', {
    attrs: {
      "col": "1fr 1fr",
      "row": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('h3', [_vm._v("Update Videos")]), _vm._v(" "), _c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.updateCacheVideo()
      }
    }
  }, [_vm._v("Update Video Cache")])]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedVideo),
      expression: "selectedVideo"
    }],
    ref: "videoSelector",
    staticClass: "video-list-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedVideo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.selected()
      }],
      "focus": function($event) {
        _vm.changeColor()
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a video")]), _vm._v(" "), _vm._l((_vm.videos), function(item, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": item.title
      }
    }, [_vm._v(_vm._s(item.title))])
  })], 2)]), _vm._v(" "), _vm._l((_vm.videos), function(item, key) {
    return _c('div', {
      key: key
    }, [(_vm.selectedVideo === item.title) ? _c('div', {
      staticClass: "draggable-items flex center-flex-y"
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "podcast-buttons"
    }, [_c('button', {
      on: {
        "click": function($event) {
          _vm.removeVideoItem(item)
        }
      }
    }, [_vm._v("Remove")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.editVideoItem(item)
        }
      }
    }, [_vm._v("Edit")])])]) : _vm._e()])
  }), _vm._v(" "), _c('grid-x', {
    staticClass: "edit-video",
    attrs: {
      "col": "1fr 1fr",
      "row": "1fr",
      "gap": ".5em"
    }
  }, [(_vm.editVideoMode) ? _c('div', [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Video Slug")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editVideo.key),
      expression: "editVideo.key"
    }],
    attrs: {
      "type": "text",
      "placeholder": "New Video Slug"
    },
    domProps: {
      "value": (_vm.editVideo.key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editVideo, "key", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Video Title")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editVideo.obj.title),
      expression: "editVideo.obj.title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "New Video Title"
    },
    domProps: {
      "value": (_vm.editVideo.obj.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editVideo.obj, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Video ID")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editVideo.obj.id),
      expression: "editVideo.obj.id"
    }],
    attrs: {
      "type": "text",
      "placeholder": "New Video ID"
    },
    domProps: {
      "value": (_vm.editVideo.obj.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editVideo.obj, "id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("SEO Title")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editVideo.obj.seoTitle),
      expression: "editVideo.obj.seoTitle"
    }],
    attrs: {
      "type": "text",
      "placeholder": "SEO Title"
    },
    domProps: {
      "value": (_vm.editVideo.obj.seoTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editVideo.obj, "seoTitle", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("SEO Description")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editVideo.obj.seoDescription),
      expression: "editVideo.obj.seoDescription"
    }],
    attrs: {
      "type": "text",
      "placeholder": "SEO Description"
    },
    domProps: {
      "value": (_vm.editVideo.obj.seoDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editVideo.obj, "seoDescription", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-top": "20px",
      "float": "left"
    },
    on: {
      "click": _vm.executeEditVideo
    }
  }, [_vm._v("Save Changes")])]) : _vm._e(), _vm._v(" "), (_vm.editVideoMode) ? _c('div', [_c('h3', {
    staticClass: "social-image-title"
  }, [_vm._v("Social Image")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "display": "block"
    },
    attrs: {
      "src": _vm.editVideo.obj.socialImage
    }
  }), _vm._v(" "), _c('ic-firebase-upload', {
    attrs: {
      "path": "images",
      "max-files": "1",
      "getFileName": _vm.getFileName,
      "storage": _vm.storage
    },
    on: {
      "uploaded": _vm.onUploadedVideoSocialImage,
      "upload": _vm.onUpload,
      "delete": _vm.onDelete
    }
  })], 1) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('h3', [_vm._v("New Video")]), _vm._v(" "), _c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.showNewVideo = !_vm.showNewVideo
      }
    }
  }, [_vm._v("New Video")])]), _vm._v(" "), (_vm.showNewVideo) ? _c('div', [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Video Slug")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newVideo.key),
      expression: "newVideo.key"
    }],
    staticStyle: {
      "display": "block",
      "width": "180px"
    },
    attrs: {
      "type": "text",
      "placeholder": "New Video Slug"
    },
    domProps: {
      "value": (_vm.newVideo.key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newVideo, "key", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Video Title")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newVideo.obj.title),
      expression: "newVideo.obj.title"
    }],
    staticStyle: {
      "display": "block",
      "width": "180px"
    },
    attrs: {
      "type": "text",
      "placeholder": "New Video Title"
    },
    domProps: {
      "value": (_vm.newVideo.obj.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newVideo.obj, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Video ID")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newVideo.obj.id),
      expression: "newVideo.obj.id"
    }],
    staticStyle: {
      "display": "block",
      "width": "180px"
    },
    attrs: {
      "type": "text",
      "placeholder": "New Video ID"
    },
    domProps: {
      "value": (_vm.newVideo.obj.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newVideo.obj, "id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("SEO Title")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newVideo.obj.seoTitle),
      expression: "newVideo.obj.seoTitle"
    }],
    staticStyle: {
      "display": "block",
      "width": "180px"
    },
    attrs: {
      "type": "text",
      "placeholder": "SEO Title"
    },
    domProps: {
      "value": (_vm.newVideo.obj.seoTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newVideo.obj, "seoTitle", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("SEO Description")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newVideo.obj.seoDescription),
      expression: "newVideo.obj.seoDescription"
    }],
    staticStyle: {
      "display": "block",
      "width": "180px"
    },
    attrs: {
      "type": "text",
      "placeholder": "SEO Description"
    },
    domProps: {
      "value": (_vm.newVideo.obj.seoDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newVideo.obj, "seoDescription", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Social Image")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newVideo.obj.socialImage),
      expression: "newVideo.obj.socialImage"
    }],
    staticStyle: {
      "display": "block",
      "width": "180px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Social Image"
    },
    domProps: {
      "value": (_vm.newVideo.obj.socialImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newVideo.obj, "socialImage", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-top": "20px",
      "float": "left"
    },
    on: {
      "click": _vm.createVideo
    }
  }, [_vm._v("Create Video Series Entry")])]) : _vm._e()])]), _vm._v(" "), (_vm.editVideoMode) ? _c('div', [_c('h3', [_vm._v("All Videos")]), _vm._v(" "), _vm._l((_vm.videoEpisodes), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "draggable-items all-videos flex center-flex-y"
    }, [_c('div', {
      staticClass: "all-video-buttons center-flex-y"
    }, [_c('span', [_vm._v(_vm._s(_vm.timestampToDate(item.timestamp)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.executeRemoveVideo(item)
        }
      }
    }, [_vm._v("Remove")])])
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05977250"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/videos.vue
// module id = 620
// module chunks = 1